// Port of api/fuel/app/classes/insights/ratings/trending.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import RatingsFilter from 'offline/filter/ratings'

export default Segment.extend({
	name: 'trending',
	types: [Constants.TYPE_USER],
	insight: ['trending.direction'],
	run: function(type, owner, userIndex, detail, filter) {

		if (!owner.get_count_ratings()) return {}

		var direction = (filter['trending.direction'] !== undefined) ? filter['trending.direction'] : 'up'
		var limit = detail ? 100 : 5

		// PHP trending passes `limit` to the filter directly so the search/
		// package pipeline only materialises the top-N rows. The JS port had
		// `perpage = owner.get_count_ratings()` which forced the pipeline to
		// fetch and package every rated game (824 rows for nicknelson) just
		// to slice to the top 5 below. We only ever read the top `limit`
		// rows from the result, so packaging more than `limit` is waste.
		var trendingIndex = RatingsFilter.forge({
			owner: owner,
			cache: false,
			filter: {
				source: {
					ratings: true
				},
				sort: 'rating.' + direction + '.absolute',
				sortReverse: true,
				context: {}
			},
			page: 1,
			perpage: limit,
			knownUsers: []
		}).run().to_array()

		var trending = []

		if (trendingIndex.total) {
			var ratings = trendingIndex.ratings.slice(0, limit)
			for (var i = 0; i < ratings.length; i++) {
				var item = ratings[i]
				if (item && item.game && item.game.id) this._references.games.push(parseInt(item.game.id, 10))
				trending.push(item)
			}
		}

		return {
			trending: trending
		}

	}
})
